module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Cấu hình chung lương cho saller",
      "breadcrumbs": [{
        title: 'Quản lý saler',
        route: {
          name: 'saler'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "config-saler-salary",
    attrs: {
      "model": _vm.localConfig,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit()
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Nhân viên chính thức")]), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "employee.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiEmployee), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiEmployee[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'number', $$v)
        },
        expression: "kpiEmployee[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiEmployee[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiEmployee[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiEmployee[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiEmployee[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiEmployee[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'money', $$v)
        },
        expression: "kpiEmployee[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiEmployee[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiEmployee[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'bonus', $$v)
        },
        expression: "kpiEmployee[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiEmployee[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiEmployee[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiEmployee[index], 'month_plus', $$v)
        },
        expression: "kpiEmployee[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiEmployee[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiEmployee, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiEmployee)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "employee.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.employee.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.employee, "salary_accumulation", $$v)
      },
      expression: "localConfig.employee.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.employee.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "employee.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.employee.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.employee, "salary_by_customer", $$v)
      },
      expression: "localConfig.employee.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.employee.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "employee.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.employee.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.employee, "month_accumulation", $$v)
      },
      expression: "localConfig.employee.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.employee.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Nhân viên thử việc")]), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "trainee.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiTrainee), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiTrainee[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'number', $$v)
        },
        expression: "kpiTrainee[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiTrainee[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiTrainee[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiTrainee[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiTrainee[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiTrainee[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'money', $$v)
        },
        expression: "kpiTrainee[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiTrainee[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiTrainee[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'bonus', $$v)
        },
        expression: "kpiTrainee[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiTrainee[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiTrainee[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiTrainee[index], 'month_plus', $$v)
        },
        expression: "kpiTrainee[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiTrainee[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiTrainee, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiTrainee)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "trainee.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.trainee.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.trainee, "salary_accumulation", $$v)
      },
      expression: "localConfig.trainee.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.trainee.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "trainee.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.trainee.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.trainee, "salary_by_customer", $$v)
      },
      expression: "localConfig.trainee.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.trainee.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "trainee.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.trainee.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.trainee, "month_accumulation", $$v)
      },
      expression: "localConfig.trainee.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.trainee.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("Nhân viên parttime / CTV")]), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "parttime.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiPartTime), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiPartTime[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'number', $$v)
        },
        expression: "kpiPartTime[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiPartTime[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiPartTime[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiPartTime[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiPartTime[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiPartTime[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'money', $$v)
        },
        expression: "kpiPartTime[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiPartTime[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiPartTime[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'bonus', $$v)
        },
        expression: "kpiPartTime[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiPartTime[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiPartTime[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiPartTime[index], 'month_plus', $$v)
        },
        expression: "kpiPartTime[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiPartTime[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiPartTime, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiPartTime)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "parttime.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.parttime.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.parttime, "salary_accumulation", $$v)
      },
      expression: "localConfig.parttime.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.parttime.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "parttime.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.parttime.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.parttime, "salary_by_customer", $$v)
      },
      expression: "localConfig.parttime.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.parttime.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "parttime.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.parttime.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.parttime, "month_accumulation", $$v)
      },
      expression: "localConfig.parttime.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.parttime.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02adb90e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/salerConfig/SalerConfig.vue
// module id = 627
// module chunks = 1